import axios from "axios";

const getLoggingScanByMawbID = (mawbID) => {

  if (!mawbID) {
    return {
      data: []
    }
  }
  return axios
    .get(`/logging/${mawbID}`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

export {
  getLoggingScanByMawbID
}
